export interface EnvelopeEvent {
  eventId: string;
  sequence: number;
  eventType: string;
  level: number;
  stepId?: string;
  clientTime: string;
  payload: Record<string, unknown>;
}

export interface EventEnvelope {
  instanceId: string;
  sessionId: string;
  experimentId: string;
  experimentVersionId: string;
  events: EnvelopeEvent[];
}

export function buildEnvelope(
  instanceId: string,
  sessionId: string,
  experimentId: string,
  experimentVersionId: string,
  events: EnvelopeEvent[],
): EventEnvelope {
  return { instanceId, sessionId, experimentId, experimentVersionId, events };
}
